<template>
  <div class="summary">
    <h1>Bestellübersicht</h1>
    <div class="summary__main-data summary__item">
      <h4 class="title">Art des Kaufes</h4>
      <p :style="{marginBottom: order.fleet_hub ? '0' : '15px'}">
        <span v-if="order.private_buyer">
          Privatkauf
        </span>
        <span v-else>
          gewerblicher Kauf
        </span>
      </p>
      <p v-if="order.fleet_hub" style="margin-bottom:15px">
        Fleet-Hub Kunde
      </p>
      <h4 class="title">Ihre Daten</h4>
      <div class="summary__main-data--content">
        <ul>
          <li>{{ fullName }}</li>
          <li>{{ order.billing_address.street }}</li>
          <li>{{ order.billing_address.zip_and_city }}</li>

          <li
            v-if="order.billing_address.street != order.delivery_address.street"
            style="margin: 10px 0"
          >
            <h4>Lieferadresse</h4>
          </li>

          <li
            v-if="order.billing_address.street != order.delivery_address.street"
          >
            {{ order.contact_person }}
          </li>
          <li
            v-if="order.billing_address.street != order.delivery_address.street"
          >
            {{ order.delivery_address.street }}
          </li>
          <li
            v-if="order.billing_address.street != order.delivery_address.street"
          >
            {{ order.delivery_address.zip }} {{ order.delivery_address.city }}
          </li>
        </ul>
        <dl>
          <div v-if="order.private_buyer">
            <dt>Geburtsdatum:</dt>
            <dd>{{ birthdayDate }}</dd>
          </div>
          <div v-if="!order.private_buyer">
            <dt>Firmenname:</dt>
            <dd>{{ order.company.name }}</dd>
          </div>
          <div v-if="!order.private_buyer">
            <dt>Umsatzsteuer-ID:</dt>
            <dd>{{ order.company.tax_number }}</dd>
          </div>
          <div>
            <dt>Telefon:</dt>
            <dd>{{ order.phone }}</dd>
          </div>
          <div>
            <dt>E-Mail:</dt>
            <dd>{{ order.email }}</dd>
          </div>
        </dl>
      </div>
      <button class="edit-btn" type="button" @click="$emit('editData')">
        bearbeiten
      </button>
    </div>
    <div v-if="commercialBuyer" class="summary__item fee-package">
        <h4>Bereitstellungspauschale</h4>
        <dl>
          <div>
            <dt>
              Einmalige Pauschale <i class="fas fa-info-circle" @click="openFleetModal" style="cursor:pointer" />
            </dt>
            <dd><strong>€ 475 ,- </strong><span class="mwst block">inkl. Mwst.</span></dd>
          </div>
        </dl>
        <button class="edit-btn" type="button" @click="$emit('editData')">
          bearbeiten
        </button>
      </div>
    <div class="summary__item warranty-package">
      <h4>Garantie</h4>
      <dl>
        <div v-if="order.warranty_extension === 'basic'">
          <dt>PKW.de-Basic-Schutz</dt>
          <dd>€ 0 ,-</dd>
        </div>
        <div v-else-if="order.warranty_extension === 'classic'">
          <dt>Klassik-Schutz</dt>
          <dd>€ 150 ,- <span class="mwst block">inkl. Mwst.</span></dd>
        </div>
        <div v-else-if="order.warranty_extension === 'premium'">
          <dt>Premium-Schutz</dt>
          <dd>€ 270 ,- <span class="mwst block">inkl. Mwst.</span></dd>
        </div>
        <div v-else-if="order.warranty_extension === 'premium_plus'">
          <dt>Premium-Plus-Schutz</dt>
          <dd>€ 680 ,- <span class="mwst block">inkl. Mwst.</span></dd>
        </div>
      </dl>
      <button class="edit-btn" type="button" @click="$emit('editWarranty')">
        bearbeiten
      </button>
    </div>
    <div class="summary__item friday-warranty-package">
      <h4>Autoversicherung</h4>
      <template v-if="order.friday_insurance">
        <p>
          <b>Ja</b>, ich bin an einem <b>unverbindlichen Angebot</b> für eine
          Autoversicherung interessiert.
          <br />
          <b>FRIDAY Original</b>: Zum Preis-Leistungs-Sieger ab 7,49 Euro pro
          Monat
        </p>
        <ul class="check-list">
          <li>Digital in 90 Sekunden abschließen</li>
          <li>Faire kilometergenaue Abrechnung</li>
          <!-- <li>Monatlich kündbar</li> -->
        </ul>
        <button
          class="edit-btn"
          type="button"
          @click="$emit('editFridayWarranty')"
        >
          bearbeiten
        </button>
      </template>
      <template v-else>
        <p>
          <b>Nein</b>, ich möchte kein Angebot zur Autoversicherung erhalten.
        </p>
        <button
          class="edit-btn"
          type="button"
          @click="$emit('editFridayWarranty')"
        >
          bearbeiten
        </button>
      </template>
    </div>

    <!--    <div class="summary__item">-->
    <!--      <h4>Autoversicherung</h4>-->
    <!--      <div v-if="order.car_insurance">-->
    <!--        <div class="radio-form-item__top-content">-->
    <!--          <p>-->
    <!--            <b>Ja,</b> ich bin an einem unverbindlichen Angebot für eine Autoversicherung interessiert.-->
    <!--          </p>-->
    <!--          <p>-->
    <!--            <b>FRIDAY Original:</b> Zum Preis-Leistungs-Sieger ab 7,49 Euro pro Monat-->
    <!--          </p>-->
    <!--          <ul class="check-list">-->
    <!--            <li>Einfach und günstig</li>-->
    <!--            <li>Von Auto Zeitung als Preis-Leistungs-Sieger ausgezeichnet</li>-->
    <!--            <li>Monatlich kündbar</li>-->
    <!--          </ul>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div v-else>-->
    <!--        <p><strong>Nein,</strong> ich möchte kein Angebot zur Autoversicherung erhalten</p>-->
    <!--      </div>-->
    <!--      <button class="edit-btn" type="button" @click="$emit('editWarranty')">bearbeiten</button>-->
    <!--    </div>-->
    <div class="summary__item">
      <h4 class="title">Zahlungsart</h4>
      <div v-if="order.payment_method === 'self_pay'">
        <h5>Barkauf</h5>
        <p>
          Zahlung des kompletten Fahrzeugpreises erfolgt nach Vertragsabschluss
          via Überweisung.
        </p>
        <button class="edit-btn" type="button" @click="$emit('editFinancing')">
          bearbeiten
        </button>
      </div>
      <div v-else>
        <h5>Online-Finanzierung</h5>
        <p>Gleichbleibend {{ withBallon ? "mit" : "ohne" }} Schlussrate</p>
        <div class="summary__financing-list">
          <dl>
            <div>
              <dt>Fahrzeugpreis</dt>
              <dd>{{ formattedPrice(order.car_info.price.customer, 2) }}</dd>
            </div>
            <div>
              <dt>Einmalige Anzahlung</dt>
              <dd>{{ formattedPrice(order.first_payment_raw, 2) }}</dd>
            </div>
            <div>
              <dt>Nettodarlehensbetrag</dt>
              <dd>{{ formattedPrice(order.financing_amount_raw, 2) }}</dd>
            </div>
            <div>
              <dt>Vertragslaufzeit</dt>
              <dd>{{ order.term }}</dd>
            </div>
            <div>
              <dt>Mtl. Rate à</dt>
              <dd>{{ formattedPrice(order.monthly_rate_raw, 2) }}</dd>
            </div>
            <div>
              <dt>Schlussrate (letzte Rate)</dt>
              <dd>{{ formattedPrice(order.last_payment_raw, 2) }}</dd>
            </div>
            <div>
              <dt>Darlehensgesamtbetrag</dt>
              <dd>{{ formattedPrice(order.total_amount_raw, 2) }}</dd>
            </div>
          </dl>
          <p class="summary__financing-efficient">
            <span>({{ order.annual_interest_rate }} Effektiver Jahreszins)</span>
          </p>
        </div>
        <button class="edit-btn" type="button" @click="$emit('editFinancing')">
          bearbeiten
        </button>
      </div>
    </div>
    <div
      :class="[
        'summary__item',
        { edited: financingEdited, 'with-price': order.registration_service !== SELF },
      ]"
    >
      <h4>Zulassung des Fahrzeugs</h4>
      <p v-if="financingEdited" class="edited-msg">
        Wir haben die Zulassungsart geändert, da Sie Ihre Zahlungsart geändert
        haben. Eine Selbst-Zulassung ist nur bei Barkauf möglich.
      </p>
      <RegistrationByPkw :order="order" v-if="order.registration_service === STANDARD" />
      <RegistrationByPkwWithPlates :order="order" v-else-if="order.registration_service === WITH_PLATES" />
      <NotApprovedContent :order="order" v-else-if="order.registration_service === SELF" />
      <button class="edit-btn" type="button" @click="$emit('editApproval')">
        bearbeiten
      </button>
    </div>
    <div
      :class="[
        'summary__item',
        { 'with-price': order.delivery_method !== 'standard' },
      ]"
    >
      <h4>Lieferoptionen</h4>
      <DeliveryContent
        v-if="order.delivery_method === 'standard'"
        :order="order"
      />
      <NoDeliveryContent v-else :order="order" />
      <button class="edit-btn" type="button" @click="$emit('editDelivery')">
        bearbeiten
      </button>
    </div>
    <div class="summary__item">
      <h4>Winterreifen auf Stahlfelgen</h4>
      <div v-if="order.winter_tires_option === 'economy'">
        <div style="display:flex;margin-bottom:10px;">
          <img
            src="../assets/images/tire-winter-icon.png"
            alt="Winter tire"
            style="margin-right:20px;width:60px;height:60px;"
          />
          <div>
            <p><b>Economy-Winterreifen</b></p>
            <p>
              Sicherheit bei Schnee und Glätte - zum optimalen
              Preis-Leistungsverhältnis
            </p>
          </div>
          <div style="text-align:right;flex-grow: 1;width:120px">
            <b>Angebot folgt</b>
          </div>
        </div>
      </div>
      <div v-if="order.winter_tires_option === 'premium'">
        <div style="display:flex;margin-bottom:10px;">
          <img
            src="../assets/images/tire-winter-icon.png"
            alt="Winter tire"
            style="margin-right:20px;width:60px;height:60px;"
          />
          <div>
            <p>
              <span class="fa-stack fa-sm" style="font-size: 12px;">
                <i class="fa fa-circle fa-stack-2x" style="color:#006EBD"></i>
                <i
                  class="fa fa-star fa-stack-1x"
                  style="color: #ffffff;font-size: 9px;"
                ></i>
              </span>
              <b>Premium-Winterreifen</b>
            </p>
            <p>
              Markenqualität von Premiumherstellern - getestete Sicherheit der
              Spitzenklasse
            </p>
          </div>
          <div style="text-align:right;flex-grow: 1;width:120px">
            <b>Angebot folgt</b>
          </div>
        </div>
      </div>
      <div v-if="order.winter_tires_option === 'none'">
        <div style="display:flex;margin-bottom:10px;">
          <img
            src="../assets/images/tire-icon.png"
            alt="Winter tire"
            style="margin-right:20px;width:60px;height:60px;"
          />
          <div>
            <p><b>Keine Winterräder</b></p>
            <p>
              Ich möchte keine Winterräder. Witterungsbedingte Verzögerungen bei
              der Lieferung meines Wunschfahrzeugs nehme ich in Kauf
            </p>
          </div>
        </div>
      </div>
      <!-- <div v-if="order.winter_tires">
        <p><strong>Ja,</strong> bitte organisieren Sie den Kauf und die Montage von Winter- oder Allwetterreifen vor dem Transport.</p>
      </div>
      <div v-else>
        <p><strong>Nein,</strong> ich möchte keine Winter- oder Allwetterreifen.</p>
        <p class="delivery-form__note">
          <i class="fas fa-check" /> Hiermit nehme ich zur Kenntnis, dass der/die Fahrer*in die Fahrzeugüberführung auf eigener Achse (bis 3,5t) bei winterlichen Straßenverhältnissen verweigert und sich die Überführung daher verzögern kann.
        </p>
      </div> -->
      <button class="edit-btn" type="button" @click="$emit('editDelivery')">
        bearbeiten
      </button>
    </div>
    <div class="summary__item">
      <h4>Kontaktpräferenz</h4>
      <div v-if="order.only_available_online">
        <strong>Nur online</strong>
        <p>
          Ich wünsche keinen telefonischen Kontakt und möchte die gesamte
          Kommunikation inkl. Vertragsabschluss online durchführen. Falls
          meinerseits Fragen aufkommen, kann ich jederzeit unter +49 (0)211 –
          9462 55-0 anrufen.
        </p>
      </div>
      <div v-else>
        <strong>Telefonisch</strong>
        <p>
          Ich willige in die telefonische Kontaktaufnahme ein. Sollte PKW.de für
          die weitere Abwicklung nähere Informationen benötigen, darf PKW.de
          mich hierzu anrufen. Falls meinerseits Fragen aufkommen, kann ich
          jederzeit unter +49 211 946 255 0 anrufen.
        </p>
      </div>
      <button class="edit-btn" type="button" @click="$emit('editContact')">
        bearbeiten
      </button>
    </div>
    <div class="car-details__create-finish">
      <button @click="$emit('finalizeOrderCreate')" type="button">
        {{ submitBtnText }}
      </button>
      <p>
        {{ finishText }}
      </p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { formatPrice } from "@/utils/price-helpers";
import ApprovedContent from "@/components/ApprovedContent";
import RegistrationByPkw from "@/components/RegistrationByPkw";
import RegistrationByPkwWithPlates from "@/components/RegistrationByPkwWithPlates";
import NotApprovedContent from "@/components/NotApprovedContent";
import DeliveryContent from "@/components/DeliveryContent";
import NoDeliveryContent from "@/components/NoDeliveryContent";
import { getFinancingPlans } from "@/api/financing";
import { SELF, STANDARD, WITH_PLATES } from "./ApprovalPkwForm.vue";

const selfPayFinishText =
  'Je nach der von Ihnen angegebenen Kontaktpräferenz schicken wir Ihnen nach Klick auf "Jetzt verbindlich bestellen" innerhalb von einem Werktag den Kaufvertrag per Mail. Wenn Sie ein Beratungstelefonat wünschen, erhalten Sie den Kaufvertrag nach Abschluss des Telefonats ebenfalls per Mail.';
const financingFinishText =
  'Schließen Sie die Finanzierung ganz einfach und bequem online ab. Nach Klick auf "Zum Finanzierungsantrag" werden Sie hierzu auf die Online-Antragsstrecke unserer Partnerbank weitergeleitet. Den Kaufvertrag erhalten Sie nach genehmigter Finanzierung von uns per Mail.';

export default {
  components: {
    ApprovedContent,
    RegistrationByPkw,
    RegistrationByPkwWithPlates,
    NotApprovedContent,
    DeliveryContent,
    NoDeliveryContent,
    RegistrationByPkw
},
  props: ["order", "financingEdited", "car"],
  computed: {
    birthdayDate() {
      return moment(this.order.birthday, "YYYY-MM-DD").format("DD.MM.YYYY");
    },
    withBallon() {
      return this.order.last_payment_raw !== 0;
    },
    fullName() {
      const { name, surname, gender } = this.order;
      const genderTitle = { male: "Herr", female: "Frau", diverse: "Divers" };
      return `${genderTitle[gender]} ${name} ${surname}`;
    },
    finishText() {
      return this.order.payment_method === "self_pay"
        ? selfPayFinishText
        : financingFinishText;
    },
    submitBtnText() {
      return this.order.payment_method === "self_pay"
        ? "Jetzt verbindlich bestellen"
        : "Zum Finanzierungsantrag";
    },
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
  },
  mounted() {
    console.log('props.car', this.car);
  },
  data() {
    return {
      SELF, STANDARD, WITH_PLATES,
      withBallonInterest: 0,
      withoutBallonInterest: 0,
    }
  },
  methods: {
    formattedPrice(num, fixedDigits) {
      return `€ ${formatPrice(num, fixedDigits)} ,-`;
    }
  },
};
</script>

<style lang="scss" scoped>
.summary {
  padding: 30px 0.625rem;
  h1 {
    margin-bottom: 30px;
  }
  @include breakpoint(desktop) {
    padding: 0;
  }
  &__note {
    margin-top: 10px;
  }
  .car-details__create-finish {
    max-width: 330px;
    width: 100%;
    margin-left: auto;
    background: white;
    margin: 1rem 0;

    button {
      position: relative;
      display: block;
      width: 100%;
      padding: 15px 10px;
      margin-bottom: 15px;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      background-color: $red;
      color: $white;
      transition: all 0.5s;
      border-radius: 50px;
      &:after {
        @include icon("\f105", $white, 18px);
      }
      &:hover,
      &:focus,
      &:active {
        background: $darkgray;
      }
    }
    p {
      font-size: 12px;
      line-height: 14px;
    }
  }
  h4 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  &__item {
    padding: 10px;
    margin-bottom: 20px;
    line-height: 26px;
    border: 1px solid #d6d6d6;
    @include breakpoint(desktop) {
      padding: 30px;
    }

    &.fee-package,
    &.warranty-package {
      dl > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 700;
      }
    }
    dl {
      margin: 15px 0 5px;
    }
    .edited-msg {
      color: $red;
    }
    &.edited {
      > div {
        margin-top: 10px;
        padding: 25px 20px;
        background-color: rgba($red, 0.1);
      }
    }
  }
  &__financing-efficient {
    font-size: 13px;
    margin-bottom: 10px;
  }
  &__financing-list {
    dl {
      > div {
        display: flex;
      }
      dt {
        width: 200px;
      }
      dd {
        margin-left: 10px;
      }
    }
  }
  &__main-data {
    dl {
      > div {
        display: flex;
      }
    }
  }
}
</style>

<style lang="scss">
.summary {
  .radio-form-item__top-content > p {
    margin-left: 0;
    margin-bottom: 10px;
  }

  // .radio-form-item__price {
  //   display: none;
  // }
  &__item {
    &.with-price {
      .radio-form-item__price {
        display: block;
      }
    }
  }

  .radio-form-item__top-content {
    padding-left: 0;
  }
  .radio-form-item__top-content > div h4 {
    padding-left: 0 !important;
  }

  h5 {
    font-size: 16px;
  }
  .edit-btn {
    margin: 10px 0;
    color: $red;
  }
  .check-list {
    padding: 10px 0;
    button {
      color: $red;
    }
    li {
      margin-left: 0;
      &:before {
        color: $red;
      }
    }
  }
  .summary__main-data--content {
    dd {
      margin-left: 10px;
    }
    dt {
      width: 125px;
    }
  }

  .delivery-form__note {
    padding-left: 0;
    font-size: 14px;
    line-height: 22px;
    margin: 20px 0;
  }

  @include breakpoint(desktop) {
    .radio-form-item__main-content {
      display: flex;
      > * {
        flex: 1;
      }
    }

    .summary__main-data--content {
      display: flex;
      > * {
        flex: 1;
      }
      dl {
        margin-top: 0;
      }
    }
  }
}
</style>
